import {
  Button,
  DatePicker,
  Divider,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Space,
} from "antd";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import {
  CalenderIcon,
  CaseAlertIcon,
  ExpandIcon,
  EyeForInputField,
  EyeIcon,
} from "icons";
import Search from "antd/es/input/Search";
import { useEffect, useMemo, useRef, useState } from "react";
import { childKeys, formData } from "pages/cases-detail/constants";
import dayjs from "dayjs";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { CalendarOutlined, PlusOutlined } from "@ant-design/icons";
import { SingleFormItemDetail } from "../singleInputHistory";
import { UseLazyApiCallV2 } from "hooks";
import { useRecoilState } from "recoil";
import { caseStatus } from "store/atom";
import { useLocation } from "react-router-dom";

export const SingleInput = ({
  item,
  totalFormData,
  setTotalFormData,
  handleUpdateCase,
  dropdownsListObj,
  refetchDropdownsListObj,
  updateCaseLoading,
  caseHistoryUpdateLoading,
  clickedItem,
}) => {
  const undieOptions = ["JA", "Nein"];
  const damageOptions = ["Totalschaden", "Reparatur"];

  const radioOptions = item?.key === "UNDIE" ? undieOptions : damageOptions;
  const location = useLocation();

  const { popupOrigin, category } = location?.state || {};
  const { refetchList } = item || {};

  const { translator } = useLanguageTranslator();
  const reminderTrans = translator("caseDetail.reminder");
  const caseFormTrans = translator("caseDetail.form");
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);

  const [
    addCompanyToDB,
    { data: fileUrlData, isLoading: fileUrlLoading, error: fileUrlError },
  ] = UseLazyApiCallV2({
    url: "/add_insurance_company",
    method: "POST",
  });

  // useEffect(() => {
  //   if (popupOrigin && category && !openAlertModal) {
  //     setOpenAlertModal(true);
  //   }
  // }, []);

  function handleChangeInput(event) {
    const { name, value } = event.target;

    setTotalFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  function handleBlurInput() {
    if (item?.isParent) return;
    handleUpdateCase();
  }

  function handleChangeDate(date, dateString) {
    setTotalFormData((prev) => ({
      ...prev,
      [item.key]: dateString,
    }));

    handleUpdateCase(item.key, dateString);
  }

  const { InputSuffixIcon } = item;
  const inputId = `input-${item?.id}`;

  function handleCloseAlert() {
    setOpenAlertModal(false);
  }

  function getFormateDate(date) {
    if (date && item.type === "date") {
      if (date?.includes(".")) {
        const format = date?.replace(/\./g, "-");
        return dayjs(format, ["DD-MM-YYYY", "DD-MM-YY"], true);
      } else if (date?.includes("-")) {
        return dayjs(totalFormData[item.key]);
      }
    }
  }
  const [items, setItems] = useState(["jack", "lucy"]);
  const [name, setName] = useState("");
  const inputRef = useRef(null);
  const onNameChange = (event) => {
    setName(event.target.value);
  };
  const addItem = (e) => {
    e.preventDefault();
  };

  function handleSelect(e, data) {
    setTotalFormData((prev) => ({
      ...prev,
      [item.key]: data?.label,
    }));

    handleUpdateCase(item.key, data?.label);
  }

  function handleClickParentKey(item) {
    if (item?.isParent) {
      clickedItem(item);
      // setOpenAlertModal(true);
    }
  }

  const total = useMemo(() => {
    const combinedValue = item?.sections
      ?.map((section) =>
        section.childs
          .map((child) => totalFormData[child.key] || "")
          .filter(Boolean)
          .join(", "),
      )
      .filter(Boolean)
      .join(" | ");

    return combinedValue;
  }, [totalFormData]);

  function isValuePresent({ totalFormData, item }) {
    if (item?.key === "customerName") {
      return !!totalFormData[item.key] || !!totalFormData["address"];
    } else {
      return !!totalFormData[item.key];
    }
  }
  async function addCompany() {
    if (!name)
      return message.error(translator("caseDetail.form.companyNameRequired"));
    try {
      const data = await addCompanyToDB({
        params: {
          companyName: name,
        },
      });
      if (data) {
        setName("");
        await refetchList();
      }
    } catch (error) {}
  }

  return (
    <div className={styles.singleField}>
      <div className={styles.numberAndField}>
        <ConditionalRenderer condition={item?.LabelIcon}>
          <div className={styles.labelIcon}>
            {item?.LabelIcon ? <item.LabelIcon /> : null}
          </div>
        </ConditionalRenderer>
        <ConditionalRenderer condition={item?.id}>
          <span
            className={styles.number}
            style={{
              backgroundColor: isValuePresent({ totalFormData, item })
                ? "#1AA260"
                : "#C2C2C2",
            }}
          >
            {item?.id}.{" "}
          </span>
        </ConditionalRenderer>
        <div
          className={styles.inputContainer}
          onClick={(e) => {
            e.stopPropagation();

            handleClickParentKey(item);
          }}
        >
          <div
            className={`${styles.label} ${
              item?.isClientMasterData ? styles.clientLabel : ""
            }`}
          >
            {caseFormTrans[item?.key]}
            <ConditionalRenderer
              condition={Boolean(caseFormTrans?.[`${item?.key}_notes`])}
            >
              <span>{`(${caseFormTrans[`${item?.key}_notes`]})`}</span>
            </ConditionalRenderer>
            <ConditionalRenderer condition={item?.required}>
              <div className={styles.required}>*</div>
            </ConditionalRenderer>
          </div>
          <ConditionalRenderer
            condition={item?.type === "text" || item?.type === "number"}
          >
            <div className={styles.input}>
              <Input
                maxLength={!item?.isParent && 40}
                readOnly={item?.isParent}
                style={{
                  backgroundColor: item?.active ? "lightyellow" : "",
                  border: item?.active
                    ? "1px solid #DEDEDE"
                    : isValuePresent({ totalFormData, item })
                      ? "1px solid #1AA260"
                      : "",
                }}
                name={item.key}
                id={inputId}
                type={"text"}
                // type={item?.inputType || "text"}
                // placeholder={caseFormTrans.enterText}
                // prefix={InputSuffixIcon ? <InputSuffixIcon /> : null}
                suffix={
                  <ConditionalRenderer
                    // condition={true}
                    condition={item?.key !== "FileReferenceSmile"}
                  >
                    <ExpandIcon
                      style={{
                        height: "12px",
                        width: "12px",
                        cursor: "pointer",
                        marginRight: "3px",
                      }}
                      className={styles.alertIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        // setOpenAlertModal(true);
                        clickedItem(item);
                      }}
                    />
                  </ConditionalRenderer>
                }
                value={item?.isParent ? total : totalFormData[item.key]}
                onChange={handleChangeInput}
                onBlur={handleBlurInput}
                disabled={item?.disabled || caseStatusOpenOrClosed === "closed"}
              />
            </div>
          </ConditionalRenderer>
          <ConditionalRenderer condition={item?.type === "date"}>
            <div className={styles.datePickerWrapper}>
              <DatePicker
                maxDate={item?.allow === "tillToday" ? dayjs() : undefined}
                inputReadOnly
                disabled={caseStatusOpenOrClosed === "closed" || item?.disabled}
                style={{
                  width: "100%",
                  backgroundColor: item?.active ? "lightyellow" : "",
                  border: item?.active
                    ? "1px solid #DEDEDE"
                    : totalFormData[item.key]
                      ? "1px solid #1AA260"
                      : "",
                }}
                placeholder={""}
                // placeholder={"DD.MM.YYYY"}
                // prefix={<CalendarOutlined style={{ color: "#1677ff" }} />} // prefix calendar icon
                allowClear={false}
                format="DD.MM.YYYY"
                value={
                  totalFormData[item.key] &&
                  getFormateDate(totalFormData[item.key])
                }
                onChange={handleChangeDate}
                name={item.key}
                // suffixIcon={InputSuffixIcon ? <InputSuffixIcon /> : null}
                suffixIcon={
                  <ExpandIcon
                    style={{
                      height: "12px",
                      width: "12px",
                      cursor: "pointer",
                      marginRight: "3px",
                    }}
                    className={styles.alertIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      // setOpenAlertModal(true);
                      clickedItem(item);
                    }}
                  />
                }
              />
              {/* <Input
            name={item.key}
            id={inputId}
            type="text"
            placeholder="Click here to enter text"
            suffix={InputSuffixIcon ? <InputSuffixIcon /> : null}
            value={totalFormData[item.key]}
            onChange={handleChangeInput}
          /> */}
            </div>
          </ConditionalRenderer>
          <ConditionalRenderer condition={item?.type === "dropdown"}>
            <div
              className={`${styles.dropdownWrapper} ${
                totalFormData[item.key] ? styles.selected : ""
              }`}
            >
              <Select
                className="antd-select-truncate"
                disabled={caseStatusOpenOrClosed === "closed"}
                showSearch
                allowClear
                filterOption={(
                  input,
                  option, // 👈 filter logic
                ) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                suffixIcon={null}
                value={totalFormData[item.key]}
                style={{
                  width: "100%",
                  height: "40px",
                }}
                placeholder=""
                onChange={handleSelect}
                dropdownRender={
                  item?.key === "insurer"
                    ? (menu) => (
                        <>
                          {menu}
                          <Divider style={{ margin: "8px 0" }} />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Input
                              placeholder={translator("enterItem")}
                              // ref={inputRef}
                              value={name}
                              onChange={onNameChange}
                              onKeyDown={(e) => e.stopPropagation()}
                              className={styles.addItemInput}
                              maxLength={50}
                            />
                            <Button
                              className={styles.addItemInputBtn}
                              type="text"
                              icon={<PlusOutlined />}
                              style={{ fontWeight: "bold" }}
                              onClick={addCompany}
                            >
                              {translator("addItem")}
                            </Button>
                          </div>
                        </>
                      )
                    : undefined
                }
                options={item?.dropdownList}
              />
              <div style={{ position: "absolute", top: "10px", right: "8px" }}>
                <ExpandIcon
                  style={{
                    height: "12px",
                    width: "12px",
                    cursor: "pointer",
                    zIndex: "1111",
                  }}
                  className={styles.alertIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickedItem(item);
                    // setOpenAlertModal(true);
                  }}
                />
              </div>
            </div>
          </ConditionalRenderer>
          <ConditionalRenderer condition={item?.type === "radio"}>
            <div className={styles.radioInput}>
              <Radio.Group
                options={radioOptions}
                defaultValue={radioOptions[0]}
              />
            </div>
          </ConditionalRenderer>
        </div>
      </div>
    </div>
  );
};

function ModalTitle({ entryName, reminderTrans, caseFormTrans }) {
  return <div className={styles.modalTitle}>{caseFormTrans[entryName]}</div>;
}
